import React, { useState, useEffect } from "react";
import { Slider } from "antd";
import "./Slider.css";
import "./Sidebar.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as faStarSolid } from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarRegular } from "@fortawesome/free-regular-svg-icons";
import { amenityIconFilterClass } from "../../../utils/amenityIcon";
const amenities = [
  {
    name: "Game zone",
    icon: {
      file: "/Game Zone.svg",
    },
  },
  {
    name: "Game zone",
    icon: {
      file: "/Game Zone.svg",
    },
  },
  {
    name: "Game zone",
    icon: {
      file: "/Game Zone.svg",
    },
  },
  {
    name: "Game zone",
    icon: {
      file: "/Game Zone.svg",
    },
  },
  {
    name: "Game zone",
    icon: {
      file: "/Game Zone.svg",
    },
  },
  {
    name: "Game zone",
    icon: {
      file: "/Game Zone.svg",
    },
  },
  {
    name: "Game zone",
    icon: {
      file: "/Game Zone.svg",
    },
  },
  {
    name: "Game zone",
    icon: {
      file: "/Game Zone.svg",
    },
  },
  {
    name: "Game zone",
    icon: {
      file: "/Game Zone.svg",
    },
  },
  {
    name: "Game zone",
    icon: {
      file: "/Game Zone.svg",
    },
  },
  {
    name: "Game zone",
    icon: {
      file: "/Game Zone.svg",
    },
  },
  {
    name: "Game zone",
    icon: {
      file: "/Game Zone.svg",
    },
  },
  {
    name: "Game zone",
    icon: {
      file: "/Game Zone.svg",
    },
  },
  {
    name: "Game zone",
    icon: {
      file: "/Game Zone.svg",
    },
  },
];

const cancellationPolicies = [
  "Free Upto 28 Days",
  "Free Upto 14 Days",
  "Non-refundable",
];
const prePaymentPolicies = [
  "30%",
  "40%",
  "50%",
  "60%",
  "70%",
  "80%",
  "90%",
  "100%",
];

const SidebarMobile = ({amenities, query, setQuery,isAmenityOpen,setIsAmenityOpen}) => {

  //console.log(amenities)
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(500000);
  const [minRating, setMinRating] = useState(0);
  const [maxRating, setMaxRating] = useState(10);
  const [rating, setRating] = useState(0);
  
  //open and close
  const [amenitiesOpen, setAmenitiesOpen] = useState(true);
  const [rangeOpen, setRangeOpen] = useState(true);
  const [ratingOpen, setRatingOpen] = useState(true);
  const [prepaymentOpen, setPrepaymentOpen] = useState(true);
  const [cancellationOpen, setCancellationOpen] = useState(true);
  const [mealsOpen, setMealsOpen] = useState(true);
  ////
  const [prePaymentPolicy, setPrePaymentPolicy] = useState("");
  const [cancellationPolicy, setCancellationPolicy] = useState("");
  const [breakfast, setBreakfast] = useState(false);
  const [lunch, setLunch] = useState(false);
  const [dinner, setDinner] = useState(false);

  const [amenitiesFlag, setAmenitiesFlag] = useState(
    Array(amenities.length).fill(false)
  );

  const [cancellationFlag, setCancellationFlag] = useState([
    false,
    false,
    false,
  ]);

  const [paymentFlag, setPaymentFlag] = useState(
    Array(prePaymentPolicies.length).fill(false)
  );

  const handleAmenities = (i) => {
    setAmenitiesFlag((prevArray) => {
      const newArray = [...prevArray];
      newArray[i] = !newArray[i];
      return newArray;
    });
  };

  // Handles the checking and unchecking of prepayment policy checkboxes
  const handlePayment = (ind) => {
    setPaymentFlag((prevArray) => {
      const newArray = Array(prePaymentPolicies).fill(false);
      newArray[ind] = !prevArray[ind];
      return newArray;
    });
  };

  // to update the state variables of prepayment policy
  useEffect(() => {
    if (paymentFlag.every((val) => !val)) {
      setPrePaymentPolicy("");
    } else {
      const ind = paymentFlag.findIndex((val) => val === true);
      setPrePaymentPolicy(prePaymentPolicies[ind]);
    }
  }, [paymentFlag]);

  // Handles the checking and unchecking of cancellation policy checkboxes
  const handleCancellation = (ind) => {
    setCancellationFlag((prevArray) => {
      const newArray = Array(3).fill(false);
      newArray[ind] = !prevArray[ind];
      return newArray;
    });
  };

  // to update the state variables of cancellation policy
  useEffect(() => {
    if (cancellationFlag.every((val) => !val)) {
      setCancellationPolicy("");
    } else {
      const ind = cancellationFlag.findIndex((val) => val === true);
      setCancellationPolicy([cancellationPolicies[ind]]);
    }
  }, [cancellationFlag]);

  //Slider
  const steps = ["0 Rs","5000 Rs", "10,000 Rs", "25,000 Rs", "50,000 Rs", "100,000 Rs","500,000 Rs"]; // Define your custom steps here

  const log = (value) => {
    //console.log(steps[value[0]], steps[value[1]]);
    
    const minPrice = parseInt(steps[value[0]].replace(/\D/g,''));
    const maxPrice = parseInt(steps[value[1]].replace(/\D/g,''));
    
    setMinPrice(minPrice);
    setMaxPrice(maxPrice);
  };

  //////////QUERY GENERATION///////////////////
  // Generates the query string based on state variables
  const formQuery = () => {
    let queryString = "";
    if (cancellationPolicy) {
      const selected = Array.isArray(cancellationPolicy)
        ? cancellationPolicy[0]
        : cancellationPolicy;
      if (selected === "Free Upto 28 Days") {
        queryString += `&cancellation_policy=FREE_UPTO_28_DAYS`;
      } else if (selected === "Free Upto 14 Days") {
        queryString += `&cancellation_policy=FREE_UPTO_14_DAYS`;
      } else if (selected === "Non-refundable") {
        queryString += `&cancellation_policy=NON_REFUNDABLE`;
      } else if (selected === "Free Upto 7 Days") {
        queryString += `&cancellation_policy=FREE_UPTO_7_DAYS`;
      } else if (selected === "Free Upto 48 Hours") {
        queryString += `&cancellation_policy=FREE_UPTO_48_HOURS`;
      }
    }
    queryString += `&min_a2z_score=${minRating * 10}&max_a2z_score=${
      maxRating * 10
    }`;
    if (breakfast) queryString += `&is_breakfast=${breakfast}`;
    if (lunch) queryString += `&is_lunch=${lunch}`;
    if (dinner) queryString += `&is_dinner=${dinner}`;
    queryString += `&min_price_guest_pay=${minPrice}&max_price_guest_pay=${maxPrice}`;
    queryString += `&page_size=20`;
    let amenitiesQuery = "&amenities=";
    let amenitiesQuery2 = amenitiesQuery;
    amenities.forEach((item, i) => {
      if (amenitiesFlag[i]) {
        amenitiesQuery += `${item.id}+`;
      }
    });
    if (amenitiesQuery !== amenitiesQuery2)
      amenitiesQuery = amenitiesQuery.slice(0, -1);
    queryString += amenitiesQuery;

    if (prePaymentPolicy !== "") {
      let preTemp = `&prepayment=`;
      preTemp += prePaymentPolicy.slice(0, -1);
      queryString += preTemp;
    }

    return queryString;
  };

  useEffect(() => {
    let temp = formQuery();
    //console.log("Inside here!");
    //console.log(temp);
    setQuery(temp);
  }, [amenities]);

  // Handles the click of apply filters button and updates the query string
  const handleApply = () => {
    let temp = formQuery();
    // //console.log(temp);
    setQuery(temp);
    //console.log("Final query .......", query);
  };

   // To handle the click of clear filters button
   const handleClear = () => {
    setMinPrice(0);
    setMaxPrice(50000);
    setMinRating(0);
    setMaxRating(10);
    setPrePaymentPolicy("");
    setCancellationPolicy("");
    setBreakfast(false);
    setLunch(false);
    setDinner(false);
    setAmenitiesFlag(Array(amenities.length).fill(false));
    setPaymentFlag(Array(prePaymentPolicies.length).fill(false));
    setCancellationFlag(Array(3).fill(false));
    setRating(0)
  };
  ////////////////////////////////////////
  return (
    <>
    {isAmenityOpen && (<aside className="bg-[#141626] fixed inset-0 overflow-auto h-screen  font-jt flex  justify-center z-[1000]">
       <div className="  w-full lg:w-[290px]  py-4 px-7 overflow">
        <div className="flex flex-row justify-between  py-4">
          <h1 className="text-[#FFFFFF] font-bold text-[26px] mr-2">Filters</h1>
          <div className="grid grid-cols-3 w-full    text-center items-center">
            <div
              className=" bg-white border-2 rounded-full hover:scale-110 transition-all cursor-pointer mx-auto text-black p-1 w-[70px] text-[16px] font-semibold"
                onClick={() => {
                  handleApply();
                  setIsAmenityOpen(!isAmenityOpen)
                }}
            >
              Apply
            </div>
            <div
              className=" mx-auto bg-white border-2 rounded-full hover:scale-110 transition-all cursor-pointer text-black p-1 w-[70px] text-[16px] font-semibold"
                onClick={() => {
                  handleClear();
                }}
            >
              Clear
            </div>
            <div
              className=" flex justify-end ml-6  p-1 w-[70px] text-[16px] font-semibold"
                onClick={() => {
                  setIsAmenityOpen(!isAmenityOpen);
                }}
            >
              <svg
              width="30"
              height="30"
              viewBox="0 0 34 34"
              fill="#FFF"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.0001 1.41666C13.918 1.41666 10.9051 2.3306 8.34245 4.04292C5.77979 5.75524 3.78243 8.18902 2.60297 11.0365C1.4235 13.884 1.1149 17.0173 1.71618 20.0401C2.31747 23.063 3.80164 25.8397 5.98101 28.0191C8.16038 30.1984 10.9371 31.6826 13.9599 32.2839C16.9828 32.8852 20.1161 32.5766 22.9636 31.3971C25.8111 30.2176 28.2448 28.2203 29.9572 25.6576C31.6695 23.095 32.5834 20.0821 32.5834 17C32.5834 12.867 30.9416 8.90335 28.0192 5.98091C25.0967 3.05847 21.133 1.41666 17.0001 1.41666ZM23.6683 21.6651C23.8036 21.7958 23.9116 21.9521 23.9858 22.1249C24.0601 22.2978 24.0991 22.4837 24.1008 22.6718C24.1024 22.8599 24.0666 23.0464 23.9953 23.2205C23.9241 23.3946 23.8189 23.5528 23.6859 23.6858C23.5529 23.8188 23.3947 23.924 23.2206 23.9952C23.0465 24.0665 22.86 24.1023 22.6719 24.1007C22.4837 24.099 22.2979 24.06 22.125 23.9857C21.9522 23.9115 21.7959 23.8035 21.6652 23.6682L17.0001 19.0032L12.335 23.6682C12.2043 23.8035 12.048 23.9115 11.8752 23.9857C11.7023 24.06 11.5164 24.099 11.3283 24.1007C11.1402 24.1023 10.9537 24.0665 10.7796 23.9952C10.6055 23.924 10.4473 23.8188 10.3143 23.6858C10.1813 23.5528 10.0761 23.3946 10.0048 23.2205C9.93361 23.0464 9.89777 22.8599 9.8994 22.6718C9.90103 22.4837 9.94011 22.2978 10.0144 22.1249C10.0886 21.9521 10.1965 21.7958 10.3318 21.6651L14.9969 17L10.3318 12.3349C10.1965 12.2042 10.0886 12.0479 10.0144 11.8751C9.94011 11.7022 9.90103 11.5163 9.8994 11.3282C9.89777 11.1401 9.93361 10.9536 10.0048 10.7795C10.0761 10.6054 10.1813 10.4472 10.3143 10.3142C10.4473 10.1812 10.6055 10.076 10.7796 10.0047C10.9537 9.93351 11.1402 9.89767 11.3283 9.8993C11.5164 9.90094 11.7023 9.94002 11.8752 10.0143C12.048 10.0885 12.2043 10.1964 12.335 10.3317L17.0001 14.9968L21.6652 10.3317C21.7959 10.1964 21.9522 10.0885 22.125 10.0143C22.2979 9.94002 22.4837 9.90094 22.6719 9.8993C22.86 9.89767 23.0465 9.93351 23.2206 10.0047C23.3947 10.076 23.5529 10.1812 23.6859 10.3142C23.8189 10.4472 23.9241 10.6054 23.9953 10.7795C24.0666 10.9536 24.1024 11.1401 24.1008 11.3282C24.0991 11.5163 24.0601 11.7022 23.9858 11.8751C23.9116 12.0479 23.8036 12.2042 23.6683 12.3349L19.0033 17L23.6683 21.6651Z"
                fill="#D00808"
              />
            </svg>
            </div>
          </div>
        </div>
        <svg
          className=""
          width="240"
          height="1"
          viewBox="0 0 310 1"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="310"
            height="1"
            rx="0.5"
            fill="url(#paint0_linear_76_1453)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_76_1453"
              x1="-1.29925e-06"
              y1="0.333501"
              x2="309.974"
              y2="-2.66679"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="white" stop-opacity="0" />
              <stop offset="0.518433" stop-color="white" />
              <stop offset="1" stop-color="white" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>

        <div className="mb-8 mt-6 flex flex-col">
          <div className="flex flex-row items-center justify-between ">
            <div className="text-[#FFFFFF] text-[18px] font-semibold">
              Popular Amenities
            </div>
            <div
              className="hover:cursor-pointer"
              onClick={() => {
                setAmenitiesOpen(!amenitiesOpen);
              }}
            >
              {amenitiesOpen && (
                <svg
                  width="11"
                  height="7"
                  viewBox="0 0 11 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.7162 5.86738L10.6564 5.79766L6.14082 0.601367C5.98809 0.425391 5.75898 0.315821 5.50332 0.315821C5.24766 0.315821 5.01855 0.428711 4.86582 0.601367L0.353516 5.7877L0.277149 5.87402C0.220703 5.95703 0.1875 6.05664 0.1875 6.16289C0.1875 6.45176 0.433204 6.6875 0.738672 6.6875L10.2613 6.6875C10.5668 6.6875 10.8125 6.45176 10.8125 6.16289C10.8125 6.05332 10.776 5.95039 10.7162 5.86738Z"
                    fill="white"
                  />
                </svg>
              )}
              {!amenitiesOpen && (
                <svg
                  width="11"
                  height="7"
                  viewBox="0 0 23 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.760742 2.62598L0.883789 2.76953L10.1807 13.4678C10.4951 13.8301 10.9668 14.0557 11.4932 14.0557C12.0195 14.0557 12.4912 13.8232 12.8057 13.4678L22.0957 2.79004L22.2529 2.6123C22.3691 2.44141 22.4375 2.23633 22.4375 2.01758C22.4375 1.42285 21.9316 0.9375 21.3027 0.9375H1.69727C1.06836 0.9375 0.5625 1.42285 0.5625 2.01758C0.5625 2.24316 0.637695 2.45508 0.760742 2.62598Z"
                    fill="white"
                  />
                </svg>
              )}
            </div>
          </div>
          <div>
            {amenitiesOpen && (
              <ul className="grid grid-cols-2 gap-[15px] mt-4">
                {amenities?.map((item, i) => (
                  <li>
                    <div
                      className= {`flex flex-col hover:cursor-pointer items-center justify-center relative  font-medium text-black  rounded-lg text-[15px] py-1 ${amenitiesFlag[i]?"bg-purple-200":"bg-[#F8F8F8] "}`}
                      onClick={() => {
                        handleAmenities(i);
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={amenitiesFlag[i]}
                        className=" accent-black absolute left-1 top-1 "
                      />
                      {item.name === "Please Wait..." ? (
                        <i className="fa-solid fa-spinner"></i>
                      ) : (
                        <img
                          src={item.icon.file}
                          alt={item.name}
                          width={"40px"}
                          className={`h-[40px] w-[40px] object-contain ${amenityIconFilterClass(item.name)}`}
                        />
                      )}

                      <span className={`font-semibold ${item.name.length > 10 ? 'text-[12px]' : 'text-base'}`}>{item.name}</span>


                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
        <div className="mb-8 flex flex-col">
          <div className="flex flex-row items-center justify-between ">
            <div className="text-[#FFFFFF] text-[18px] font-semibold">
              Price Range
            </div>
            <div
              className="hover:cursor-pointer"
              onClick={() => {
                setRangeOpen(!rangeOpen);
              }}
            >
              {rangeOpen && (
                <svg
                  width="11"
                  height="7"
                  viewBox="0 0 11 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.7162 5.86738L10.6564 5.79766L6.14082 0.601367C5.98809 0.425391 5.75898 0.315821 5.50332 0.315821C5.24766 0.315821 5.01855 0.428711 4.86582 0.601367L0.353516 5.7877L0.277149 5.87402C0.220703 5.95703 0.1875 6.05664 0.1875 6.16289C0.1875 6.45176 0.433204 6.6875 0.738672 6.6875L10.2613 6.6875C10.5668 6.6875 10.8125 6.45176 10.8125 6.16289C10.8125 6.05332 10.776 5.95039 10.7162 5.86738Z"
                    fill="white"
                  />
                </svg>
              )}
              {!rangeOpen && (
                <svg
                  width="11"
                  height="7"
                  viewBox="0 0 23 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.760742 2.62598L0.883789 2.76953L10.1807 13.4678C10.4951 13.8301 10.9668 14.0557 11.4932 14.0557C12.0195 14.0557 12.4912 13.8232 12.8057 13.4678L22.0957 2.79004L22.2529 2.6123C22.3691 2.44141 22.4375 2.23633 22.4375 2.01758C22.4375 1.42285 21.9316 0.9375 21.3027 0.9375H1.69727C1.06836 0.9375 0.5625 1.42285 0.5625 2.01758C0.5625 2.24316 0.637695 2.45508 0.760742 2.62598Z"
                    fill="white"
                  />
                </svg>
              )}
            </div>
          </div>
          {rangeOpen && (
            <div className="mt-[38px] w-[95%]">
              <Slider
                range
                defaultValue={[0, 5]}
                onAfterChange={log}
                tooltipVisible
                max={steps.length - 1}
                tipFormatter={(value) => steps[value]}
              />
            </div>
          )}
        </div>

        <div className="mb-8 flex flex-col">
          <div className="flex flex-row items-center justify-between ">
            <div className="text-[#FFFFFF] text-[18px] font-semibold">
              Ratings
            </div>
            <div
              className="hover:cursor-pointer"
              onClick={() => {
                setRatingOpen(!ratingOpen);
              }}
            >
              {ratingOpen && (
                <svg
                  width="11"
                  height="7"
                  viewBox="0 0 11 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.7162 5.86738L10.6564 5.79766L6.14082 0.601367C5.98809 0.425391 5.75898 0.315821 5.50332 0.315821C5.24766 0.315821 5.01855 0.428711 4.86582 0.601367L0.353516 5.7877L0.277149 5.87402C0.220703 5.95703 0.1875 6.05664 0.1875 6.16289C0.1875 6.45176 0.433204 6.6875 0.738672 6.6875L10.2613 6.6875C10.5668 6.6875 10.8125 6.45176 10.8125 6.16289C10.8125 6.05332 10.776 5.95039 10.7162 5.86738Z"
                    fill="white"
                  />
                </svg>
              )}
              {!ratingOpen && (
                <svg
                  width="11"
                  height="7"
                  viewBox="0 0 23 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.760742 2.62598L0.883789 2.76953L10.1807 13.4678C10.4951 13.8301 10.9668 14.0557 11.4932 14.0557C12.0195 14.0557 12.4912 13.8232 12.8057 13.4678L22.0957 2.79004L22.2529 2.6123C22.3691 2.44141 22.4375 2.23633 22.4375 2.01758C22.4375 1.42285 21.9316 0.9375 21.3027 0.9375H1.69727C1.06836 0.9375 0.5625 1.42285 0.5625 2.01758C0.5625 2.24316 0.637695 2.45508 0.760742 2.62598Z"
                    fill="white"
                  />
                </svg>
              )}
            </div>
          </div>
          {ratingOpen && (
            <div className="mt-2">
              <div>
                {[...Array(5)].map((star, i) => {
                  const ratingValue = i + 1;
                  return (
                    <label key={i} className="p-1 cursor-pointer">
                      <input
                        type="radio"
                        name="rating"
                        value={ratingValue}
                        onClick={() => {
                          setRating(ratingValue);
                          setMinRating((ratingValue * 2) - 1);
                          setMaxRating(ratingValue * 2);
                        }}
                        style={{ display: "none" }}
                      />
                      <FontAwesomeIcon
                        icon={
                          ratingValue <= rating ? faStarSolid : faStarRegular
                        }
                        color={ratingValue <= rating ? "#FCCC24" : "white"}
                        size="xl"
                      />
                    </label>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        <div className="mb-8 flex flex-col">
          <div className="flex flex-row items-center justify-between ">
            <div className="text-[#FFFFFF] text-[18px] font-semibold">
              Prepayment Policy
            </div>
            <div
              className="hover:cursor-pointer"
              onClick={() => {
                setPrepaymentOpen(!prepaymentOpen);
              }}
            >
              {prepaymentOpen && (
                <svg
                  width="11"
                  height="7"
                  viewBox="0 0 11 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.7162 5.86738L10.6564 5.79766L6.14082 0.601367C5.98809 0.425391 5.75898 0.315821 5.50332 0.315821C5.24766 0.315821 5.01855 0.428711 4.86582 0.601367L0.353516 5.7877L0.277149 5.87402C0.220703 5.95703 0.1875 6.05664 0.1875 6.16289C0.1875 6.45176 0.433204 6.6875 0.738672 6.6875L10.2613 6.6875C10.5668 6.6875 10.8125 6.45176 10.8125 6.16289C10.8125 6.05332 10.776 5.95039 10.7162 5.86738Z"
                    fill="white"
                  />
                </svg>
              )}
              {!prepaymentOpen && (
                <svg
                  width="11"
                  height="7"
                  viewBox="0 0 23 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.760742 2.62598L0.883789 2.76953L10.1807 13.4678C10.4951 13.8301 10.9668 14.0557 11.4932 14.0557C12.0195 14.0557 12.4912 13.8232 12.8057 13.4678L22.0957 2.79004L22.2529 2.6123C22.3691 2.44141 22.4375 2.23633 22.4375 2.01758C22.4375 1.42285 21.9316 0.9375 21.3027 0.9375H1.69727C1.06836 0.9375 0.5625 1.42285 0.5625 2.01758C0.5625 2.24316 0.637695 2.45508 0.760742 2.62598Z"
                    fill="white"
                  />
                </svg>
              )}
            </div>
          </div>
          {prepaymentOpen && (
            <ul className="grid grid-cols-3 gap-3 mt-4">
              {prePaymentPolicies.map((item, i) => {
                return (
                  <li>
                    <button
                      onClick={() => {
                        handlePayment(i);
                      }}
                      className="flex flex-row items-center font-medium text-[#FFFFFF] text-[15px]"
                    >
                      <input
                        type="checkbox"
                        checked={paymentFlag[i]}
                        className="hidden"
                      />
                      <label
                        htmlFor="custom-checkbox"
                        className={`w-4 h-4 mr-3 flex justify-center items-center cursor-pointer rounded-full border-2 ${
                          paymentFlag[i]
                            ? "border-black bg-black"
                            : "border-gray-300 bg-white"
                        }`}
                      >
                        {paymentFlag[i] && (
                          <svg
                            className="w-4 h-4 text-white"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                        )}
                      </label>
                      <h1 className="ml-2 text-center ">{item}</h1>
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
        </div>

        <div className="mb-8 flex flex-col">
          <div className="flex flex-row items-center justify-between ">
            <div className="text-[#FFFFFF] text-[18px] font-semibold">
              Cancellation Policy
            </div>
            <div
              className="hover:cursor-pointer"
              onClick={() => {
                setCancellationOpen(!cancellationOpen);
              }}
            >
              {cancellationOpen && (
                <svg
                  width="11"
                  height="7"
                  viewBox="0 0 11 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.7162 5.86738L10.6564 5.79766L6.14082 0.601367C5.98809 0.425391 5.75898 0.315821 5.50332 0.315821C5.24766 0.315821 5.01855 0.428711 4.86582 0.601367L0.353516 5.7877L0.277149 5.87402C0.220703 5.95703 0.1875 6.05664 0.1875 6.16289C0.1875 6.45176 0.433204 6.6875 0.738672 6.6875L10.2613 6.6875C10.5668 6.6875 10.8125 6.45176 10.8125 6.16289C10.8125 6.05332 10.776 5.95039 10.7162 5.86738Z"
                    fill="white"
                  />
                </svg>
              )}
              {!cancellationOpen && (
                <svg
                  width="11"
                  height="7"
                  viewBox="0 0 23 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.760742 2.62598L0.883789 2.76953L10.1807 13.4678C10.4951 13.8301 10.9668 14.0557 11.4932 14.0557C12.0195 14.0557 12.4912 13.8232 12.8057 13.4678L22.0957 2.79004L22.2529 2.6123C22.3691 2.44141 22.4375 2.23633 22.4375 2.01758C22.4375 1.42285 21.9316 0.9375 21.3027 0.9375H1.69727C1.06836 0.9375 0.5625 1.42285 0.5625 2.01758C0.5625 2.24316 0.637695 2.45508 0.760742 2.62598Z"
                    fill="white"
                  />
                </svg>
              )}
            </div>
          </div>
          {cancellationOpen && (
            <ul className="mt-3">
              {cancellationPolicies.map((item, i) => {
                return (
                  <li>
                    <button
                      onClick={() => {
                        handleCancellation(i);
                      }}
                      className="py-1 flex items-center font-medium text-[#FFFFFF] text-[15px]"
                    >
                      <input
                        type="checkbox"
                        checked={cancellationFlag[i]}
                        className=" hidden"
                      />
                      <label
                        htmlFor="custom-checkbox"
                        className={`w-4 h-4 mr-3 flex justify-center items-center cursor-pointer rounded-full border-2 ${
                          cancellationFlag[i]
                            ? "border-black bg-black"
                            : "border-gray-300 bg-white"
                        }`}
                      >
                        {cancellationFlag[i] && (
                          <svg
                            className="w-4 h-4 text-white"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M5 13l4 4L19 7"
                            ></path>
                          </svg>
                        )}
                      </label>
                      {item}
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
        </div>

        <div className="mb-8 flex flex-col">
          <div className="flex flex-row items-center justify-between ">
            <div className="text-[#FFFFFF] text-[18px] font-semibold">
              Meals included
            </div>
            <div
              className="hover:cursor-pointer"
              onClick={() => {
                setMealsOpen(!mealsOpen);
              }}
            >
              {mealsOpen && (
                <svg
                  width="11"
                  height="7"
                  viewBox="0 0 11 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.7162 5.86738L10.6564 5.79766L6.14082 0.601367C5.98809 0.425391 5.75898 0.315821 5.50332 0.315821C5.24766 0.315821 5.01855 0.428711 4.86582 0.601367L0.353516 5.7877L0.277149 5.87402C0.220703 5.95703 0.1875 6.05664 0.1875 6.16289C0.1875 6.45176 0.433204 6.6875 0.738672 6.6875L10.2613 6.6875C10.5668 6.6875 10.8125 6.45176 10.8125 6.16289C10.8125 6.05332 10.776 5.95039 10.7162 5.86738Z"
                    fill="white"
                  />
                </svg>
              )}
              {!mealsOpen && (
                <svg
                  width="11"
                  height="7"
                  viewBox="0 0 23 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.760742 2.62598L0.883789 2.76953L10.1807 13.4678C10.4951 13.8301 10.9668 14.0557 11.4932 14.0557C12.0195 14.0557 12.4912 13.8232 12.8057 13.4678L22.0957 2.79004L22.2529 2.6123C22.3691 2.44141 22.4375 2.23633 22.4375 2.01758C22.4375 1.42285 21.9316 0.9375 21.3027 0.9375H1.69727C1.06836 0.9375 0.5625 1.42285 0.5625 2.01758C0.5625 2.24316 0.637695 2.45508 0.760742 2.62598Z"
                    fill="white"
                  />
                </svg>
              )}
            </div>
          </div>
          {mealsOpen && (
            <ul className="flex flex-col justify-center mt-3">
              <li>
                <button
                  onClick={() => {
                    let temp = breakfast;
                    setBreakfast(!temp);
                  }}
                  className="py-1 flex items-center font-medium text-[#FFFFFF] text-[15px]"
                >
                  <input
                    type="checkbox"
                    checked={breakfast}
                    onChange={() => {
                      let temp = breakfast;
                      setBreakfast(!temp);
                    }}
                    className="mr-3 h-[15px] w-[15px] accent-black"
                  />
                  Breakfast
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    let temp = lunch;
                    setLunch(!temp);
                  }}
                  className="py-1 flex items-center font-medium text-[#FFFFFF] text-[15px]"
                >
                  <input
                    type="checkbox"
                    checked={lunch}
                    onChange={() => {
                      let temp = lunch;
                      setLunch(!temp);
                    }}
                    className="mr-3 h-[15px] w-[15px] accent-black"
                  />
                  Lunch
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    let temp = dinner;
                    setDinner(!temp);
                  }}
                  className="py-1 flex items-center font-medium text-[#FFFFFF] text-[15px]"
                >
                  <input
                    type="checkbox"
                    checked={dinner}
                    onChange={() => {
                      let temp = dinner;
                      setDinner(!temp);
                    }}
                    className="mr-3 h-[15px] w-[15px] accent-black"
                  />
                  Dinner
                </button>
              </li>
            </ul>
          )}
        </div>
      </div>
    </aside>)}
    </>
  );
};

export default SidebarMobile;
